 
export const Data_Section = 'Register_Section'
export const Account_Section = 'Account_Section'
 
export const ServiceFees_Section = 'ServiceFees'